import axios from "axios";
import React, { Component, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link, Outlet } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import StepButton from "@mui/material/StepButton";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import logo from "../images/coffee-mug-removebg-preview.png";
import Button from "react-bootstrap/Button";
import { PlusCircle, XCircleFill, Save } from "react-bootstrap-icons";
import SideBar from "../screens/Tab&Desktop/SuperAdmin/Componet/Sidebar";
import {
  Box,
  Grid,
  Paper,
  withStyles,
  Stepper,
  Step,
  StepLabel,
} from "@material-ui/core";
import Step1 from "./Steps/step1";
import Step2 from "./Steps/step2";
import Step3 from "./Steps/step3";
import Step4 from "./Steps/step4";
import { useNavigate } from "react-router-dom";
import FinalStep from "./Steps/FinalStep";
import { renderText } from "./common/DisplayComponent";
import { styles } from "./common/styles";
import { useLocation } from "react-router-dom";
import TheStep from "./Steps/theSteps";
import baseUrl from "../services/api";

function handleSubmit(data) {
 
  try {
    return axios
      .post(`${baseUrl}/coffee`, data)

      .then((response) => {
        // alert(response.data.message)
        // window.location.reload(false)
        return response.data.message;
      })
      .catch((err) => {
        console.error(err);
        return err;
      });
  } catch (error) {
    if (error.message === "Network Error") {
      alert("no internet connection");
      // dispatch({type: RELOAD});
      return error;
    }
  }
}

function FormComponent(props) {
  const navigate = useNavigate();
  // const [formDataArray, setFormDataArray] = useState([]);
  // const [count, setCount] = useState(0);
  // useEffect(() => {

  useEffect(() => { 
    axios.defaults.headers.common = {
      Authorization: `Bearer ${session_token}`,
    };


  }, []);

  const session_token = sessionStorage.getItem("token");
  
  //   console.log(`Count is now: ${count}`);
  // }, [count]);
  useEffect(() => {
    var item_value = sessionStorage.getItem("login");
    if (item_value != "1") {
      navigate("/login");
    }
    if (location?.state?.anotherVariable) {
      setEditMode(true);
    }
   
  }, []);
  function logout() {
    sessionStorage.removeItem("login");
    sessionStorage.removeItem("name");
    navigate("/login");
  }

  var item_value = sessionStorage.getItem("name");
  var date = new Date().toLocaleDateString();
  const location = useLocation();
  const val = location.state?.data;
  const update = location.state?.anotherVariable;
  var anotherVariable = 0;

  if (update == "1") {
    console.log("updte number ", update);
    anotherVariable = 1;
  }

  async function handleEditSubmit(data){
    console.log("Updatedt Data number  r r r r", data);
 await   axios
    .put(`${baseUrl}/coffeeUpdate`, data)
    .then((response) => {
      console.log("Form updated successfully", response.data);
      alert("Form updated successfully");
      session_role=='admin'?  navigate("/member"):navigate('/form');
    })
    .catch((error) => {
      alert("Error updating Form");
      console.error("Error updating Form", error);
    });
  
     
    }

  //   useEffect(()=>{
  //     console.log(props, 'props')
  //  },[])
  const state = {
    data: val
      ? val
      : {
          nameofsurveyer: item_value,
          samplecoffeeid: "",
          aciditycharacter: "",
          acidityintensity: 0,
          aciditylevel: 0,
          acidityscore: 0,
          aftertestduration: 0,
          aftertestlevel: 0,
          aftertestscore: 0,
          aging: 0,
          aromabreakcomment: "",
          aromabreakintensity: 0,
          aromadrycomment: "",
          aromadryintensity: 0,
          aromalevel: 0,
          aromascore: 0,
          aw: "",
          balancelevel: 0,
          balancescore: 0,
          characterberry: false,
          characterbrownspice: false,
          charactercitric: false,
          charactercoca: false,
          characterdriedfruit: false,
          characterfloral: false,
          characterfruity: false,
          characterherbal: false,
          characternutty: false,
          characteroverripe: false,
          characterstonefruit: false,
          charactertropical: false,
          cleancupcups1: false,
          cleancupcups2: false,
          cleancupcups3: false,
          cleancupcups4: false,
          cleancupcups5: false,
          cleancupscore: 0,
          defectsc: 0,
          defectsintensity: 0,
          defectsnote: "",
          density: "",
          fermentprofile: 0,
          finalscore: 0,
          flavourintensity: 0,
          flavourlevel: 0,
          flavourscore: 0,
          moisturecontent: "",
          mouthfeelbody: 0,
          mouthfeelcharacter: "",
          mouthfeellevel: 0,
          mouthfeelscore: 0,
          notesbreak: "",
          notesdry: "",
          notesnegative: "",
          profile: "",
          quakercount: "",
          roast: 0,
          sweetcups1: false,
          sweetcups2: false,
          sweetcups3: false,
          sweetcups4: false,
          sweetcups5: false,
          sweetnessintensity: 0,
          sweetnessscore: 0,
          totaldefects: 0,
          totalsore: 0,
          totalscore: 0,
          uniformcups1: false,
          uniformcups2: false,
          uniformcups3: false,
          uniformcups4: false,
          uniformcups5: false,
          uniformityscore: 0,
          uniquenesslevel: 0,
          uniquenessscore: 0,
        },
    errors: {},
    steps: ["Page 1", "Page 2", "Page 3", "Page 4", "Report"],
    stepCount: 0,
  };

  const [multiform, setMultiform] = useState([{ ...state }]);
  const [editMode, setEditMode] = useState(false);
  // const [datas, setData] = useState(state);
  // const [total, setTotal] = useState(state.data.totalscore);
  const [totaldefects, setTotalDefects] = useState(state.data.totaldefects);
  const [finalscore, setFinal] = useState(state.data.finalscore);

  // const [originalContent, setOriginalContent] = useState('Original content');
  const [duplicatedContents, setDuplicatedContents] = useState([]);
  const session_role = sessionStorage.getItem("role");
  const duplicateContentById = (id) => {
    // setCount(count+1);

    const originalDiv = document.getElementById(id);
    if (originalDiv) {
      const duplicatedDiv = originalDiv.cloneNode(true);
      const duplicatedHTML = duplicatedDiv.outerHTML;
      setDuplicatedContents([...duplicatedContents, duplicatedHTML]);
    }
  };

  const saveallForms = () => {};

  const duplicateLatest = () => {
    const latestContent = duplicatedContents[duplicatedContents.length - 1];
    if (latestContent) {
      setDuplicatedContents([...duplicatedContents, latestContent]);
    }
  };

  const cancelDuplicate = () => {
    // setCount(count-1);
    // if (duplicatedContents.length > 0) {
    //   const updatedDuplicatedContents = [...duplicatedContents];
    //   updatedDuplicatedContents.pop(); // Remove the last duplicated content
    //   setDuplicatedContents(updatedDuplicatedContents);
    // }
    let a = [...multiform];
    a.pop();
    setMultiform(a);
  };

  // useEffect(() => {
  //   const originalDiv = document.getElementById('originalDiv');
  //   if (originalDiv) {
  //     setOriginalContent(originalDiv.innerHTML);
  //   }
  // }, []);

  // const handleSubmit = (e) => {
  //   console.log("form submitted");
  // };

  const handleOnChange = ({ target, index }) => {
    console.log(
      "handleOnChange",
      target.value,
      target.name,
      index,
      multiform[index].data
    );

    // let copiedData= {...multiform[index],[target.name]:target.value};

    // copiedData.data[target.name] = target.value;
    // console.log(copiedData);
    setMultiform(
      multiform.map((data, ind) =>
        ind === index
          ? {
              ...multiform[index],
              data: { ...multiform[index].data, [target.name]: target.value },
            }
          : data
      )
    );
    // setData(multiform => ({
    //   ...copiedData
    // }));
  };
  const handleTotalValue = (val, index) => {
    setMultiform(
      multiform.map((data, ind) =>
        ind === index
          ? {
              ...multiform[index],
              data: { ...multiform[index].data, totalscore: val },
            }
          : data
      )
    );
    //   setTotal(val)
    //   let copiedData= {...datas};

    // copiedData.data["totalscore"] = total;
  };
  // const handleTotalDefectValue = ( val ) => {

  //   setTotalDefects(val)
  //   let copiedData= {...datas};

  // copiedData.data["totaldefects"] = totaldefects;

  // };
  // const handleFinalValue = ( val ) => {

  //   setFinal(val)
  //   let copiedData= {...datas};

  // copiedData.data["finalscore"] = finalscore;

  // };

  // const handleOnChangeUni = ({ target }) => {

  //   console.log(target.name);

  //   console.log(datas);
  //   let copiedData= {...datas};
  //   console.log(target.value);
  //   console.log(copiedData);
  //    copiedData.data[target.name] = target.value;
  //   console.log(copiedData);
  //   setData(datas => ({
  //     ...copiedData
  //   }));

  //   console.log(datas);
  // };

  // const [activeStep, setActiveStep] = useState(0);
  // const [completed, setCompleted] = useState({});

  const totalStepsY = () => {
    return state.steps.length;
  };

  // const completedStepsY = () => {
  //   return Object.keys(completed).length;
  // };

  // const isLastStepY = () => {
  //   return activeStep === totalStepsY() - 1;
  // };

  // const allStepsCompletedY = () => {
  //   return completedStepsY() === totalStepsY();
  // };

  //   const handleNextY = () => {
  //     const newActiveStep = 4;
  //     setActiveStep(newActiveStep);
  //   };

  //   const handleBackY = () => {
  //     setActiveStep((prevActiveStep) => prevActiveStep - 1);
  //   };

  //   const handleStepY = (step) => () => {
  //     setActiveStep(step);
  //   };

  //   const handleCompleteY = () => {
  //     const newCompleted = completed;
  //     newCompleted[activeStep] = true;
  //     setCompleted(newCompleted);
  //     handleNextY();
  //   };

  //   const handleResetY = () => {
  //     setActiveStep(0);
  //     setCompleted({});
  //     const stateR = {
  //   data: {
  // nameofsurveyer:"",
  // aciditycharacter: "",
  // acidityintensity: 0,
  // aciditylevel: 0,
  // acidityscore: 0,
  // aftertestduration: 0,
  // aftertestlevel: 0,
  // aftertestscore:0,
  // aging: 0,
  // aromabreakcomment: "",
  // aromabreakintensity: 0,
  // aromadrycomment: "",
  // aromadryintensity: 0,
  // aromalevel: 0,
  // aromascore: 0,
  // aw: "",
  // balancelevel: 0,
  // balancescore: 0,
  // characterberry: false,
  // characterbrownspice: false,
  // charactercitric: false,
  // charactercoca: false,
  // characterdriedfruit: false,
  // characterfloral: false,
  // characterfruity: false,
  // characterherbal: false,
  // characternutty: false,
  // characteroverripe: false,
  // characterstonefruit: false,
  // charactertropical: false,
  // cleancupcups1: false,
  // cleancupcups2: false,
  // cleancupcups3: false,
  // cleancupcups4
  // :
  // false,
  // cleancupcups5
  // :
  // false,
  // cleancupscore
  // :
  // 0,
  // created_at
  // :
  // null,
  // defectsc
  // :
  // 0,
  // defectsintensity
  // :
  // 0,
  // defectsnote
  // :
  // "",
  // density
  // :
  // "",
  // fermentprofile
  // :
  // 0,
  // finalscore
  // :
  // 0,
  // flavourintensity
  // :
  // 0,
  // flavourlevel
  // :
  // 0,
  // flavourscore
  // :
  // 0,
  // moisturecontent
  // :
  // "",
  // mouthfeelbody
  // :
  // 0,
  // mouthfeelcharacter
  // :
  // "",
  // mouthfeellevel
  // :
  // 0,
  // mouthfeelscore
  // :
  // 0,

  // notesbreak
  // :
  // "",
  // notesdry
  // :
  // "",
  // notesnegative
  // :
  // "",
  // profile
  // :
  // "",
  // quakercount
  // :
  // "",
  // roast
  // :
  // 0,
  // samplecoffeeid
  // :
  // "",
  // sweetcups1
  // :
  // false,
  // sweetcups2
  // :
  // false,
  // sweetcups3
  // :
  // false,
  // sweetcups4
  // :
  // false,
  // sweetcups5
  // :
  // false,
  // sweetnessintensity
  // :
  // 0,
  // sweetnessscore
  // :
  // 0,
  // totaldefects
  // :
  // 0,
  // totalscore
  // :
  // 0,
  // uniformcups1
  // :
  // false,
  // uniformcups2
  // :
  // false,
  // uniformcups3
  // :
  // false,
  // uniformcups4
  // :
  // false,
  // uniformcups5
  // :
  // false,
  // uniformityscore
  // :
  // 0,
  // uniquenesslevel
  // :
  // 0,
  // uniquenessscore
  // :
  // 0
  //       },
  //       errors: {},
  //       steps: [
  //         "Page 1" ,
  //         "Page 2" ,
  //         "Page 3" ,
  //         "Page 4" ,
  //         "Report" ,
  //       ],
  //       stepCount: 0,
  //     };
  //     setData(stateR);

  //   };

  console.log("gsfjfhwf ghsdjkdf hvsdfjsdfhsdf");
  // console.log(update);
  return (
    <>
      {/* <Navbar bg="dark" style={{ position: "fixed", zIndex: 999 }} expand="sm">
        <Container>
          <Navbar.Brand href="#">
            <img src={logo} alt="Logo" width={"65px"} height={"50px"} />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link>
                {" "}
                <Link to="/">Home</Link>
              </Nav.Link>
              <Nav.Link>
                <Link to={session_role === 'admin' ? '/member' : '/form'}>Dashboard</Link>
              </Nav.Link>
              <Nav.Link>
                <Link to="/history">History</Link>
              </Nav.Link>
              <NavDropdown
                className="dropdown"
                title="Settings"
                menuVariant="dark"
                drop="end"
                id="basic-nav-dropdown">
                <NavDropdown.Item onClick={logout}>Logout</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="#">Edit Profile</NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar> */}

<div class="content">
<div class="sidebar">
<SideBar/>
</div>
<div class="stuff">
<div class='col-md-2' style={{marginTop: 20, marginLeft:5}}><Button variant="secondary"><Link style={{textDecoration: 'none', color:'white', paddingTop: 15}} to={session_role === 'admin' ? '/member' : '/form'}>Dashboard</Link></Button> </div><hr/>
   <Grid container style={{overflow: 'scroll', overflowY: 'scroll', height: '100vh'}}>
  
        <Grid item xs={12} sm={7}>
          <form onSubmit={handleSubmit} className="mainForm">
            <Paper component={Box} mb={1}>
              {/* <Box pt={2}>
                  {renderText({
                    type: "h5",
                    color: "red",
                    label: "Coffee  Form",
                    align: "center",
                  })}
                </Box> */}

              {/* <Stepper nonLinear alternativeLabel activeStep={activeStep} >
                 {state.steps.map((label,index) => (

                 <Step key={label} completed={completed[index]}>
                  <StepLabel  onClick={handleStepY(index)}
                  >
                   {label}
                </StepLabel>
                </Step>
                  ))}
                
                  
                 </Stepper> */}
            </Paper>
            <>
              {multiform.map((formData, index) => (
                <div key={index} id={"originalDiv" + index}>
                  <div className="colomns">
                    <TheStep
                      data={formData.data}
                      handleChange={({ target }) =>
                        handleOnChange({ target, index })
                      }
                      count={index}
                    />
                  </div>
                </div>
              ))}

              <div
                style={{
                  margin: "15px",
                  justifyContent: "start",
                  display: "flex",
                  gap: "5px",
                }}>
                {multiform.length > 1 && (
                  <Button
                    onClick={cancelDuplicate}
                    variant="danger"
                    className="w-10">
                    <XCircleFill /> Remove
                  </Button>
                )}
                {editMode || (
                  <Button
                    onClick={() => {
                      setMultiform([...multiform, { ...state }]);
                      // duplicateContentById('originalDiv');
                    }}
                    variant="success"
                    className="w-10">
                    <PlusCircle /> New
                  </Button>
                )}

                <Button
                  onClick={(e) => {
                    console.log(multiform.length, multiform);
                    e.preventDefault();
                    let submitted = [];
                    multiform.forEach(({ data }, index) => {
                      let totalScore =
                        parseFloat(data.aromascore) +
                        parseFloat(data.flavourscore) +
                        parseFloat(data.cleancupscore) +
                        +parseFloat(data.aftertestscore) +
                        +parseFloat(data.acidityscore) +
                        parseFloat(data.mouthfeelscore) +
                        parseFloat(data.uniquenessscore) +
                        parseFloat(data.uniformityscore) +
                        parseFloat(data.balancescore) +
                        parseFloat(data.sweetnessscore);
                      let totalDefects =
                        parseFloat(data.defectsc) *
                        parseFloat(data.defectsintensity);
                      let finalData = {
                        ...data,
                        totalscore: totalScore,
                        totaldefects: totalDefects,
                        finalscore: totalScore - totalDefects,
                      };
                      console.log("finalData", finalData);
                      if (finalData.id === undefined) {
                        handleSubmit(finalData).then((res) => {
                          console.log("THERESPONSE:", index, res);
                          submitted.push(index);
                          if (submitted.length === multiform.length) {
                            alert("SUCCESSFUL");
                            window.location.reload(false);
                          }
                        });
                      } else {
                        handleEditSubmit(finalData).then((res) => {
                          console.log("THERESPONSE:", index, res);
                        });
                      }
                    });
                  }}
                  variant="info"
                  className="w-10">
                  <Save /> Save
                </Button>
              </div>
            </>
          </form>
        </Grid>
      </Grid>
  </div>
  </div>
     
    </>
  );
}

FormComponent.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FormComponent);
